import React from "react";
import GenericDialogFooter from "../../../../dialog/generic-dialog-footer/GenericDialogFooter";
import styles from "./AiAgentConfigDialogFooter.module.css";
import { CustomButton } from "../../../..";
import { translate } from "../../../../../providers";
import { AI_AGENT_CONFIG_TABS } from "../../../../../constants";

const AiAgentConfigDialogFooter = ({
	disableLaunch = false,
	disableSave = false,
	displayLaunch = false,
	instructions,
	isTemplate,
	launchTitle = "",
	onChangeStage,
	onClose,
	onLaunch,
	onSave,
	selectedTab,
	stage,
}) => (
	<GenericDialogFooter>
		<div className={styles.footer} data-is-template={isTemplate}>
			<div>
				<CustomButton color="secondary" variant="outlined" onClick={onClose}>
					{translate("common:btn.cancel")}
				</CustomButton>
			</div>
			{(selectedTab === AI_AGENT_CONFIG_TABS.CONFIGURATION ||
				selectedTab === AI_AGENT_CONFIG_TABS.QUICK_LAUNCH) && (
				<div className={styles.actionButtons}>
					{(stage === 0 && (
						<CustomButton color="primary" variant="contained" onClick={() => onChangeStage(1)}>
							{translate("common:btn.next")}
						</CustomButton>
					)) || (
						<>
							{isTemplate ? (
								<CustomButton
									color="primary"
									disabled={!instructions}
									variant="contained"
									onClick={onSave}
								>
									{translate("common:btn.submit")}
								</CustomButton>
							) : (
								<>
									<CustomButton
										color="primary"
										disabled={disableSave || selectedTab === AI_AGENT_CONFIG_TABS.QUICK_LAUNCH}
										variant="outlined"
										onClick={onSave}
									>
										{translate("common:btn.save")}
									</CustomButton>
									{displayLaunch && (
										<CustomButton
											color="primary"
											disabled={
												disableLaunch || selectedTab === AI_AGENT_CONFIG_TABS.QUICK_LAUNCH
											}
											variant="contained"
											onClick={onLaunch}
										>
											{launchTitle || translate("common:btn.launch")}
										</CustomButton>
									)}
								</>
							)}
						</>
					)}
				</div>
			)}
		</div>
	</GenericDialogFooter>
);

export default AiAgentConfigDialogFooter;
